import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { SafeUrl } from '@angular/platform-browser';

export interface PhotoViewDialogData {
  photoUrl: string | SafeUrl;
  userName?: string;
}

@Component({
  selector: 'app-photo-view-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule, TranslateModule],
  templateUrl: './photo-view-dialog.component.html',
  styleUrls: ['./photo-view-dialog.component.scss'],
})
export class PhotoViewDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PhotoViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PhotoViewDialogData,
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
